var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg050ReflectiveVest = function Svg050ReflectiveVest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 331h450v60H31zM438.666 198.329c-6.826-8.042-9.741-18.633-8.013-29.048L453.08 38.027l-59.077-14.773-22.529 136.183-29.59-4.922 22.925-138.56L301 0v19.219c0 61.501-14.841 104.982-30 122.611V301h210v-90h-15a35.74 35.74 0 0 1-27.334-12.671M46 211H31v90h210V141.83c-15.159-17.629-30-61.11-30-122.611V0l-63.807 15.956 22.923 138.531-29.59 4.922-22.527-136.155L58.92 38.027l22.427 131.254a35.76 35.76 0 0 1-8.013 29.048A35.74 35.74 0 0 1 46 211M31 421h210v91H31zM271 421h210v91H271z"
  })));
};
export default Svg050ReflectiveVest;